<template>
  <div class="no-data">
    <NuxtImg
      format="webp"
      src="/assets/images/icons/icon-nodata-news.png"
      class="mb-3"
      alt="Icon News"
      width="108"
      height="108"
      densities="1x"
      preload
    />
    <div class="no-data__title">Tin tức đang được cập nhật</div>
  </div>
</template>
<style scoped lang="scss">
@import '~scssAsset/components/common/no-data.scss';
</style>
